import request from '@/utils/request'

const baseURL = '/landsurvey-orders'

export default {
  import(formData) {
    return request({
      url: `${baseURL}/import`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  importFromPortal(data) {
    return request({
      url: `${baseURL}/import-from-portal`,
      method: 'post',
      data,
    })
  },

  list(params = {}) {
    return request({
      url: baseURL,
      method: 'get',
      params,
    })
  },
}
